export default __webpack_public_path__ + "static/clear-headings-do-459b54a0dbe68c8c8c5d6e5b67d365ef.png";